import React from 'react';

// 外站連結
const OuterLink = ({children, ...props}) => {
  return <a {...props} target="_blank" rel="noreferrer noopene">{children}</a>
}

export default OuterLink;
